const SET_MY_COVERAGE_DATA = 'myproductivity/SET_MY_COVERAGE_DATA';

export {
    SET_MY_COVERAGE_DATA
};